import { render, staticRenderFns } from "./AppDescription.vue?vue&type=template&id=8357ba26"
import script from "./AppDescription.vue?vue&type=script&lang=ts"
export * from "./AppDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports